import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumbItem = _resolveComponent("FKBreadCrumbItem")!
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_SurveyForm = _resolveComponent("SurveyForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: _ctx.$t('page.create'),
      title: _ctx.$t('page.create_survey')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.surveys'),
          to: "/surveys"
        }, null, 8 /* PROPS */, ["page"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page", "title"]),
    _createVNode(_component_SurveyForm)
  ], 64 /* STABLE_FRAGMENT */))
}